// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import avaliacaoModulo from './avaliacaoModulo.js'
import remocaoModulo from './remocaoModulo.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    avaliacao: avaliacaoModulo,
    remocao: remocaoModulo
   
  }
})